import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Parent } from '../class/parent.model';
import { Result } from '../class/result.model';
import { SharedService } from '../shared.service';

@Component({
  selector: 'persona-select',
  templateUrl: './persona-select.component.html',
  styleUrls: ['./persona-select.component.scss']
})
export class PersonaSelectComponent extends Parent implements OnInit {

  /* Focus al campo de texto */
  @ViewChild('caja_texto', { static: false })
  set input(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus()
    }
  }

  public listPersonasSelect: Array<string> = [];
  public nombres: any = '';

  @Output() modalClose = new EventEmitter<any>();

  constructor(
    private sharedService: SharedService,
    public activeModal: NgbActiveModal
  ) {
    super();
  }

  ngOnInit() {
  }

  listarPersonasSelect() {
    if (this.nombres === null || this.nombres === undefined || this.nombres === '') {
      this.listPersonasSelect = [];
      return;
    }
    if (!isNaN(this.nombres) && this.nombres.length !== 8) {
      return;
    }
    this.showProcessing = true;
    this.sharedService.listarPersonaSelect(this.nombres)
      .subscribe((result: Result) => {
        if (result.success) {
          this.listPersonasSelect = <Array<string>>result.data;
        }
        this.showProcessing = false;
      });
  }

  selectPersona(data) {
    this.modalClose.emit(data);
    this.activeModal.close();
  }

  cerrarModal() {
    this.modalClose.emit('');
    this.activeModal.close();
  }

}
